import {COUNTRY} from 'front-onceforall-core/dist/utils/country';

import {keep} from './objects';

export const MAX_QUERY_LENGTH = 50;

export const RELATIONSHIP_TYPE = {CLIENT_OF: 'CLIENT_OF', SUB_CONTRACTOR_OF: 'SUB_CONTRACTOR_OF'};
export const INVITATION_TYPE = {INTERNAL: 'INTERNAL', EXTERNAL: 'EXTERNAL'};
export const status = {PENDING: 'PENDING', ACCEPTED: 'ACCEPTED', REJECTED: 'REJECTED', CANCELLED: 'CANCELLED', ENDED: 'ENDED'};
export const notificationType = {
  DOCUMENT_REJECTED: 'DOCUMENT_REJECTED',
  DOCUMENT_EXPIRED: 'DOCUMENT_EXPIRED',
  DOCUMENT_ALMOST_EXPIRED: 'DOCUMENT_ALMOST_EXPIRED',
  DOCUMENT_VALIDATED: 'DOCUMENT_VALIDATED',
  DOCUMENT_REQUALIFIED: 'DOCUMENT_REQUALIFIED',
  DOCUMENT_CREATED: 'DOCUMENT_CREATED',
  DOCUMENT_MANDATE_DISABLED: 'DOCUMENT_MANDATE_DISABLED',
  DOCUMENT_AWAITING_SIGNATURE: 'DOCUMENT_AWAITING_SIGNATURE',
  DOCUMENT_SIGNED_ALMOST_EXPIRED: 'DOCUMENT_SIGNED_ALMOST_EXPIRED',
  DOCUMENT_SIGNED_EXPIRED: 'DOCUMENT_SIGNED_EXPIRED',
  DOCUMENT_AT_DATE: 'DOCUMENT_AT_DATE',
  DOCUMENTS_REMINDER: 'DOCUMENTS_REMINDER',
  DEPOSITOR_SERVICE_ACTIVATED: 'DEPOSITOR_SERVICE_ACTIVATED',
  PROJECT_NOT_AUTOMATICALLY_ACCEPTED: 'PROJECT_NOT_AUTOMATICALLY_ACCEPTED',
  PROJECT_AUTOMATICALLY_ACCEPTED: 'PROJECT_AUTOMATICALLY_ACCEPTED',
  PROJECT_CLOSED: 'PROJECT_CLOSED',
  PROJECT_REJECTED: 'PROJECT_REJECTED',
  RELATIONSHIP_SUGGESTED: 'RELATIONSHIP_SUGGESTED',
  RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED: 'RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED',
  RELATIONSHIP_AUTOMATICALLY_ACCEPTED: 'RELATIONSHIP_AUTOMATICALLY_ACCEPTED',
  RELATIONSHIP_REJECTED: 'RELATIONSHIP_REJECTED',
  PROJECT_ORGANISATION_ENDED: 'PROJECT_ORGANISATION_ENDED',
  USER_ROLE_UPDATED: 'USER_ROLE_UPDATED',
  USER_PERMISSIONS_UPDATED: 'USER_PERMISSIONS_UPDATED',
  USER_PENDING: 'USER_PENDING',
  USER_LINKED: 'USER_LINKED',
  RELATED_ORGANISATION_DEACTIVATED: 'RELATED_ORGANISATION_DEACTIVATED',
  INVITED_ORGANISATION_DEACTIVATED: 'INVITED_ORGANISATION_DEACTIVATED',
  REQUIRED_DOCUMENTS_IN_PROJECT_DOSSIER_OVERVIEW_UPDATED: 'REQUIRED_DOCUMENTS_IN_PROJECT_DOSSIER_OVERVIEW_UPDATED'
};
export const interventionRole = {
  CLIENT: 'CLIENT',
  GENERAL_CONTRACTOR: 'GENERAL_CONTRACTOR',
  SUB_CONTRACTOR: 'SUB_CONTRACTOR',
  SERVICE_PROVIDER: 'SERVICE_PROVIDER',
  PROJECT_MANAGER_CLIENT: 'PROJECT_MANAGER_CLIENT',
  PROJECT_MANAGER: 'PROJECT_MANAGER'
};
export const notificationStatus = {NEW: 'NEW', DISMISSED: 'DISMISSED', RESOLVED: 'RESOLVED'};
export const PROJECT_STATUS = {ACTIVE: 'ACTIVE', CLOSED: 'CLOSED'};
export const projectType = {STANDARD: 'STANDARD', NOMINATIVE: 'NOMINATIVE', FAMILY: 'FAMILY'};
/* WARNING: shall only be used in subscriptions for german organisations (not relevant for other countries) */
export const planType = {BASIC: 'de_basic_1y_v1', PROFESSIONAL: 'de_professional_1y_v1', PREMIUM: 'de_premium_1y_v1'};
export const REJECTION_REASONS = {
  UNKNOWN_CLIENT: 'UNKNOWN_CLIENT',
  WORKS_WITH_ANOTHER_ORGANISATION: 'WORKS_WITH_ANOTHER_ORGANISATION',
  NO_ACTIVE_CONTRACT: 'NO_ACTIVE_CONTRACT',
  UNKNOWN_ORGANISATION: 'UNKNOWN_ORGANISATION',
  NOT_WORKING_WITH_ORGANISATION: 'NOT_WORKING_WITH_ORGANISATION',
  NO_LONGER_WORKING_WITH_ORGANISATION: 'NO_LONGER_WORKING_WITH_ORGANISATION',
  PRICE: 'PRICE',
  NOT_INFORMED: 'NOT_INFORMED',
  ACTRADIS_MEMBER: 'ACTRADIS_MEMBER',
  INSUFFICIENT_CUSTOMERS_NUMBER: 'INSUFFICIENT_CUSTOMERS_NUMBER',
  NO_FILE_SHARING_WANTED: 'NO_FILE_SHARING_WANTED',
  PLATFORM_SECURITY_SCEPTIC: 'PLATFORM_SECURITY_SCEPTIC',
  FREE_PLATFORM_MEMBER: 'FREE_PLATFORM_MEMBER',
  KEEP_SENDING_FILE_BY_EMAIL: 'KEEP_SENDING_FILE_BY_EMAIL',
  FILE_ALREADY_TRANSMITTED: 'FILE_ALREADY_TRANSMITTED',
  NO_REASON_GIVEN: 'NO_REASON_GIVEN',
  SUBJECT_STUDIED_BY_MANAGEMENT: 'SUBJECT_STUDIED_BY_MANAGEMENT',
  UNREACHABLE: 'UNREACHABLE',
  NOT_MANDATORY: 'NOT_MANDATORY',
  WRONG_CONTACT_INFORMATIONS: 'WRONG_CONTACT_INFORMATIONS',
  DO_INVITATION_MISTAKE: 'DO_INVITATION_MISTAKE',
  INSCRIPTION_ONGOING: 'INSCRIPTION_ONGOING',
  CESSATION_OF_ACTIVITY: 'CESSATION_OF_ACTIVITY'
};
export const errorType = {
  INVITATION_ALREADY_SENT: 'INVITATION_ALREADY_SENT',
  USER_ALREADY_IN_ORGANISATION: 'INVITATION_ALREADY_IN_ORGANISATION'
};
export const errorCode = {
  SAME_INVITATION_ALREADY_PENDING: 'same-invitation-already-pending'
};
export const errorMessage = {
  USER_ALREADY_INVITED: 'user.invite.alreadyInvited',
  USER_ALREADY_IN_ORGANISATION: 'user.invite.alreadyPartOfOrganisation'
};
export const documentReminderReason = {
  APPLICATION_APPROVAL: 'APPLICATION_APPROVAL',
  SIGNATURE: 'SIGNATURE',
  CONTRACT: 'CONTRACT',
  PAYMENT: 'PAYMENT',
  ADDITIONAL_DOCUMENT: 'CREATION_ADDITIONAL_DOCUMENT',
  REPORT_ANOMALY: 'REPORT_ANOMALY'
};
export const EXPLORER_ROLE = 'EXPLORER';
export const CONSULTANT_ROLE = 'CONSULTANT';
export const INVITING_ROLE = 'INVITING';
export const MANAGER_ROLE = 'MANAGER';
export const BACKOFFICE_ROLE = 'BACK_OFFICE';
export const DEFAULT_ROLE = 'DEFAULT';
export const SIGN_PERMISSION = 'SIGN';
export const MANAGE_PROJECT_PERMISSION = 'MANAGE_PROJECT';
export const CCRD_SUBTYPE = 'CCRD_NOMINATIF';
export const CRSE_SUBTYPE = 'CRSE_NOMINATIF';
export const universignTransactionStatus = {
  INITIALIZED: 'INITIALIZED',
  PROCESSED: 'PROCESSED',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};
export const USER_REQUEST_TYPES = {
  MY_OFFER: 'MyOffer',
  MY_DOCUMENTS: 'MyDocuments',
  MY_ROLE: 'MyRole',
  MY_NETWORK: 'MyNetwork',
  MY_PROJECTS: 'MyProjects',
  MY_OPTIONS: 'MyOptions',
  MY_SETTINGS: 'MySettings',
  MY_TRAINING: 'MyTraining'
};
export const OFA_MASTER_PLATFORM = 'OFA';
export const ACTRADIS_MASTER_PLATFORM = 'ACTRADIS';
export const USER_OPTIONS = {
  COLLECTOR_PERIODIC_PROJECT_REPORT: 'COLLECTOR_PERIODIC_PROJECT_REPORT',
  SUGGESTION_DISPLAY: 'SUGGESTION_DISPLAY'
};

export const BUSINESS_LINES = {
  AGRICULTURE: 'AGRICULTURE',
  CLEANING: 'CLEANING',
  CONSTRUCTION: 'CONSTRUCTION',
  MANUFACTURING: 'MANUFACTURING',
  METAL_PRODUCTS: 'METAL_PRODUCTS',
  OTHER: 'OTHER',
  PARCEL_DELIVERY: 'PARCEL_DELIVERY',
  RENTAL_LEASING: 'RENTAL_LEASING',
  SAFETY: 'SAFETY',
  SERVICE_ACTIVITIES: 'SERVICE_ACTIVITIES',
  TEMPORARY_WORK: 'TEMPORARY_WORK',
  TRANSPORTATION: 'TRANSPORTATION',
  WASTE_MANAGEMENT: 'WASTE_MANAGEMENT'
};

export const BUSINESS_LINES_BY_COUNTRY = {
  FRANCE: Object.keys(keep(BUSINESS_LINES, ['CLEANING', 'CONSTRUCTION', 'OTHER', 'SAFETY', 'TEMPORARY_WORK', 'TRANSPORTATION'])),
  GERMANY: Object.keys(keep(BUSINESS_LINES, ['CONSTRUCTION', 'OTHER', 'PARCEL_DELIVERY'])),
  ITALY: Object.keys(keep(BUSINESS_LINES, ['CONSTRUCTION', 'TRANSPORTATION', 'METAL_PRODUCTS', 'SERVICE_ACTIVITIES', 'AGRICULTURE', 'WASTE_MANAGEMENT', 'RENTAL_LEASING', 'MANUFACTURING', 'OTHER']))
};

const ENTITY_ALG_FR = 'alg_fr';
const ENTITY_OFA_DE = 'ofa_de';
const ENTITY_OFA_IT = 'ofa_it';

export const ENTITY_BY_COUNTRY = {
  [COUNTRY.ANDORRA]: ENTITY_ALG_FR,
  [COUNTRY.BELGIUM]: ENTITY_ALG_FR,
  [COUNTRY.BOLIVIA]: ENTITY_ALG_FR,
  [COUNTRY.BULGARIA]: ENTITY_ALG_FR,
  [COUNTRY.CROATIA]: ENTITY_ALG_FR,
  [COUNTRY.CZECH_REPUBLIC]: ENTITY_ALG_FR,
  [COUNTRY.ESTONIA]: ENTITY_ALG_FR,
  [COUNTRY.FRANCE]: ENTITY_ALG_FR,
  [COUNTRY.GREECE]: ENTITY_ALG_FR,
  [COUNTRY.HUNGARY]: ENTITY_ALG_FR,
  [COUNTRY.ICELAND]: ENTITY_ALG_FR,
  [COUNTRY.INDIA]: ENTITY_ALG_FR,
  [COUNTRY.IVORY_COAST]: ENTITY_ALG_FR,
  [COUNTRY.LUXEMBOURG]: ENTITY_ALG_FR,
  [COUNTRY.MAURITIUS]: ENTITY_ALG_FR,
  [COUNTRY.MEXICO]: ENTITY_ALG_FR,
  [COUNTRY.MONACO]: ENTITY_ALG_FR,
  [COUNTRY.NETHERLANDS]: ENTITY_ALG_FR,
  [COUNTRY.POLAND]: ENTITY_ALG_FR,
  [COUNTRY.PORTUGAL]: ENTITY_ALG_FR,
  [COUNTRY.ROMANIA]: ENTITY_ALG_FR,
  [COUNTRY.SERBIA]: ENTITY_ALG_FR,
  [COUNTRY.SLOVAKIA]: ENTITY_ALG_FR,
  [COUNTRY.SLOVENIA]: ENTITY_ALG_FR,
  [COUNTRY.SPAIN]: ENTITY_ALG_FR,
  [COUNTRY.SWEDEN]: ENTITY_ALG_FR,
  [COUNTRY.SWITZERLAND]: ENTITY_ALG_FR,
  [COUNTRY.UNITED_KINGDOM]: ENTITY_ALG_FR,
  [COUNTRY.ITALY]: ENTITY_OFA_IT,
  [COUNTRY.AUSTRIA]: ENTITY_OFA_DE,
  [COUNTRY.DENMARK]: ENTITY_OFA_DE,
  [COUNTRY.GERMANY]: ENTITY_OFA_DE,
  [COUNTRY.LATVIA]: ENTITY_OFA_DE,
  [COUNTRY.LITHUANIA]: ENTITY_OFA_DE
};

export const AUTO_GENERATE_FILE_DOCUMENT_TYPE = 'ADD_SWORN_STAT';

export const DOC_TYPE = {
  FOREIGN_EMPLOYEES: 'FOREIGN_EMPLOYEES'
};

export const FIELD_CODE = {
  ADDITIONAL_DESIGNATION: 'additionalDesignation',
  THIRD_PARTY_ID_NUMBER: 'thirdPartyIdNumber',
  CERTIFYING_THIRD_PARTY: 'certifyingThirdParty',
  ISSUING_THIRD_PARTY: 'issuingThirdParty',
  INTERNAL_NOTE: 'internalNote',
  ISSUE_DATE: 'issueDate',
  VALIDITY_START_DATE: 'validityStart',
  VALIDITY_END_DATE: 'validityEnd',
  VERIFICATION_CODE: 'verificationCode',
  PROOF: 'proof',
  REFERENCE_PERIOD: 'referencePeriod',
  REFERENCE_YEAR: 'referenceYear',
  PAYROLL: 'payroll',
  STAFF: 'staff',
  WITH_CAPITALIZATION_SCHEME: 'withCapitalizationScheme',
  AMOUNT_BANK_GUARANTEE: 'amountBankGuarantee',
  TURNOVER: 'turnover',
  IBAN: 'iban',
  BIC: 'bic',
  CONTRIBUTION_RATE: 'contributionRate',
  TURNOVER_TWA: 'turnoverTwa'
};

export const FIELD_OPTION = {
  NOT_APPLICABLE: 'NA',
  REQUIRED: 'REQUIRED',
  OPTIONAL: 'OPTIONAL',
  READ_ONLY: 'READ_ONLY'
};

export const VITRINE_ACCESSED = 'VITRINE_ACCESSED';
